import SMHomeBanner from '../../containers/Home/Banner'
import SMHomeFinancingWithUs from '../../containers/Home/WithUs'
import SMHomeSteps from '../../containers/Home/ProductStep'
import SMHomeWhyApply from '../../containers/Home/WhyApply'
import SMHomeDownload from '../../containers/Home/Download'
import SMHomeFindIdeal from '../../containers/Home/FindIdeal'
import SMHomeWhatsNew from '../../containers/Home/WhatsNew'
import SMHomeContactUs from '../../containers/Home/ContactUs'

export const HomeScreen: React.FC = () => {

  // ======================= VIEWS
  return (
    <>
            <SMHomeBanner />
            <SMHomeFinancingWithUs />
            <SMHomeSteps />
            <SMHomeWhyApply />
            <SMHomeDownload />
            <SMHomeFindIdeal />
            <SMHomeWhatsNew />
            <SMHomeContactUs />
    </>
  )
}

// ======================= EXPORT
export default HomeScreen
